import { createPortal } from "react-dom"
import { toast } from "react-toastify"
import classNames from "classnames"

import { useLazyUpdateWHDevicesStatusQuery } from "store/api/warehouseManagerApi"
import { useAppSelector } from "store/hooks"
import styles from "assets/scss/index.module.scss"
import { ReactComponent as IconMissing } from "assets/svg/modal-icon-missing.svg"

import getErrorMessage from "utils/getErrorMessage"
import { ModalLayout } from "layouts/ModalLayout"

interface Props {
  onCancel: () => void
  onSuccess: () => void
}

export const ReturnFromMissingModalWarehouse = ({ onCancel, onSuccess }: Props) => {
  const [triggerUpdateWHDevices, { isFetching }] = useLazyUpdateWHDevicesStatusQuery()
  const selectedDeviceIDs = useAppSelector(state => state.tempData.selectedDeviceIDs)

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    try {
      const res = await triggerUpdateWHDevices({
        device_ids: selectedDeviceIDs,
        phisical_status: "stocked",
      })
      const error = getErrorMessage(res?.error)

      if (error) {
        toast.error(error)
      } else {
        toast.success("The status of the selected thermostat(s) was changed successfully!")
        onSuccess()
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      {createPortal(
        <ModalLayout width="450px" isFetching={isFetching} onConfirm={onSubmit} onCancel={onCancel}>
          <div className={classNames(styles.modalContent, styles.center)}>
            <IconMissing />
            <h3 className={styles.modalTitle}>Return from missing</h3>
            <div className={styles.modalMessage}>
              Are you sure you want to return the selected thermostat(s) from missing to stock?
            </div>
          </div>
        </ModalLayout>,
        document.body,
      )}
    </>
  )
}
